import { CircularProgress, Grid2, Skeleton } from "@mui/material";
import styles from "./EnvironmentStyle.module.scss";
import { ReactComponent as ToggleOn } from "../../Features/Admin/AdminAssets/svg/ToggleOn.svg";
import { CP } from "../../Utils/roconConstants";

export default function Environment(props) {
  const {
    Icon,
    label,
    shortLabel,
    width,
    status,
    staging,
    credit,
    maxCredit,
    buyStaging,
    handleToggle,
    toggleStatus,
    setAddStaging,
    selectedDomain,
    color,
    stagingStatus,
    navigate,
    orgId,
    siteId,
    location,
    isLoading,
  } = props;

  const dynamicClass = label.replace(/\s+/g, "");
  const isCreditExpired = credit === parseInt(maxCredit);
  // Pages that do not exist for a staging environment (mirrored by the Sidebar's
  // subRoute filter). Switching to staging from one of them lands on Site Details.
  const stagingUnavailablePaths = ["/domains-hosted", "/backups-restores"];
  const isStagingUnavailablePage = stagingUnavailablePaths.some((path) =>
    location?.pathname.includes(path),
  );
  const siteDetailsPath = `/account/${orgId}/${siteId}/site-details`;

  const handleClick = () => {
    if (stagingStatus === "PROVISIONING") return;

    if (isStagingUnavailablePage) {
      navigate(siteDetailsPath);
    } else {
      selectedDomain();
    }
  };

  return (
    <>
      {status ? (
        <Skeleton variant="rectangular" width={120} height={42} />
      ) : (
        <Grid2
          onClick={handleClick}
          className={`${styles.Box} ${styles[dynamicClass]}
           ${color ? styles.toggleBackground : ""} `}
          style={{
            width: width,
          }}
        >
          <div
            className={`${
              !isCreditExpired
                ? styles.tagInfoList1
                : styles.tagInfoList1Expired
            }`}
          />
          <Grid2
            className={`${
              !isCreditExpired ? styles.tagInfo : styles.tagInfoExpired
            }`}
          >
            <span className={styles.tagInfoList3}>
              {!isCreditExpired ? (
                <>
                  <span className={styles.tagInfoList4}>{credit}</span> /
                  {maxCredit}
                </>
              ) : (
                <span className={styles.tagInfoList4}>
                  {credit - maxCredit}
                </span>
              )}
              <span className={styles.hourLabel}>Hr Remaining</span>
            </span>
          </Grid2>
          {!staging ? (
            !isCreditExpired ? (
              <Grid2
                onClick={() => {
                  if (isStagingUnavailablePage) {
                    navigate(siteDetailsPath);
                  } else {
                    setAddStaging();
                  }
                }}
                className={styles.addStaging}
              >
                Add Now
              </Grid2>
            ) : (
              <Grid2
                onClick={() => {
                  if (isStagingUnavailablePage) {
                    navigate(siteDetailsPath);
                  } else {
                    buyStaging();
                  }
                }}
                className={styles.buyStaging}
              >
                Buy Now
              </Grid2>
            )
          ) : (
            staging && (
              <>
                {isLoading ? (
                  <Grid2 className={styles.loading}>
                    <CircularProgress size={CP.SIZE} color={CP.COLOR} />
                  </Grid2>
                ) : (
                  <Grid2
                    onClick={() => {
                      if (isStagingUnavailablePage) {
                        navigate(siteDetailsPath);
                      } else {
                        handleToggle();
                      }
                    }}
                    className={styles.addStaging}
                  >
                    {stagingStatus !== "PROVISIONING" ? (
                      <ToggleOn className={styles.toggle} />
                    ) : (
                      <CircularProgress size={18} color={"inherit"} />
                    )}
                  </Grid2>
                )}
              </>
            )
          )}
          <Grid2 container gap={"10px"} alignItems={"center"}>
            <Icon className={`${styles.icon} ${color ? styles.color : ""}`} />
            <Grid2 className={styles.devEnv}>
              <span
                className={`${styles.fullLabel} ${color ? styles.color : ""}`}
              >
                {label}
              </span>
              <span className={styles.shortLabel}>{shortLabel}</span>
            </Grid2>
          </Grid2>
        </Grid2>
      )}
    </>
  );
}
